var exports = {
  "k": "x61f99309--e4e3e3--container",
};

module.exports = exports;
